import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Selector from "../../Selector";
import useStyles from "./styles";
import { handleInputValidation } from "./../../../utils/inputValidations";
import { handleInputMask } from "./../../../utils/inputMasks";

const components = {
  DropdownIndicator: null,
};

const Field = ({
  label,
  selectedUser,
  placeholder,
  oldUser,
  attr,
  newInput,
  setValue,
  setValidation,
  isRequired,
  error,
  fieldLength,
  ...props
}) => {
  const classes = useStyles();
  const [isFirstRender, setIsFirstRender] = useState(true);

  const handleKeyDown = (event) => {
    if (!newInput[attr]) return;
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    isRequired &&
      setValidation({
        error: "Preencha os campos obrigatórios",
        attr: attr,
      });
  }, [isRequired, attr, setValidation]);

  return (
    <>
      <Selector
        label={label}
        isCreatable={true}
        components={components}
        inputValue={oldUser ? selectedUser[attr] : newInput[attr]}
        value={oldUser ? selectedUser[attr] : newInput[attr]}
        isClearable
        isMulti={false}
        isDisabled={oldUser}
        menuIsOpen={false}
        error={error && !isFirstRender && error[attr]}
        onInputChange={(inputValue, action) => {
          if (
            action.action !== "input-blur" &&
            action.action !== "menu-close"
          ) {
            setValue({
              key: attr,
              value: handleInputMask(attr, inputValue.substring(0, fieldLength))
            });
            setValidation({
              error: handleInputValidation(
                attr,
                inputValue.substring(0, fieldLength)
              ),
              attr: attr,
            });
            setIsFirstRender(false);
            handleInputMask(attr, inputValue.substring(0, fieldLength));
          }
        }}
        onChange={(value) => {
          if(value) {
            setValue({ key: attr, value: value.substring(0, fieldLength) });
            setValidation({
              error: handleInputValidation(attr, value.substring(0, fieldLength)),
              attr: attr,
            });
          }
        }}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={classes.field}
        width="300px"
        inputId={attr}
        {...props}
      />
      <span className={classes.error}>
        {error && !isFirstRender && error[attr]}
      </span>
    </>
  );
};

const mapState = (state) => ({
  newInput: state.users.newUser,
  error: state.users.formErrors,
});

const mapDispatch = (dispatch) => ({
  setValue: (payload) => dispatch.users.setNewUserAsync(payload),
  setValidation: (payload) => dispatch.users.setValidationAsync(payload),
});

export default connect(mapState, mapDispatch)(Field);
